import React, { useEffect, useState } from "react";
import { getDocs, collection } from "firebase/firestore";
import { db } from "../../firebase";
import {
  Button,
  Modal,
  Box,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";

const LabTestSelector = ({ onSelectLabTest }) => {
  const [labTests, setLabTests] = useState([]); // Holds the list of lab tests
  const [open, setOpen] = useState(false); // Controls modal open/close state

  // Fetch lab tests from Firestore
  useEffect(() => {
    const fetchLabTests = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "labtest"));
        const labTestList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setLabTests(labTestList); // Set the fetched lab tests to state
      } catch (error) {
        console.error("Error fetching lab tests:", error); // Handle any errors
      }
    };
    fetchLabTests(); // Call the fetch function when component mounts
  }, []);

  // Handle opening and closing of the modal
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // Handle lab test selection and pass the name and id to the parent
  const handleItemClick = (labTest) => {
    onSelectLabTest({ name: labTest.test_name, id: labTest.test_id });
    handleClose(); // Close modal after selection
  };

  return (
    <>
      <Button variant="outlined" onClick={handleOpen} sx={{ mt: 2 }}>
        Select Lab Test
      </Button>

      {/* Modal for selecting lab test */}
      <Modal
        open={open}
        onClose={handleClose}
        sx={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "40%",
            bgcolor: "background.paper",
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography variant="h6" component="h2" gutterBottom>
            Select a Lab Test
          </Typography>
          <List sx={{ maxHeight: 200, overflowY: "auto" }}>
            {labTests.map((labTest) => (
              <ListItem
                button
                key={labTest.id}
                onClick={() => handleItemClick(labTest)} // Handle selection
              >
                <ListItemText
                  primary={labTest.test_name}
                  secondary={`Category: ${labTest.category}`}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </Modal>
    </>
  );
};

// Define the expected prop types for LabTestSelector
LabTestSelector.propTypes = {
  onSelectLabTest: PropTypes.func.isRequired, // Function passed from parent component
};

export default LabTestSelector;
